import FilterList from 'projects/access-control/src/app/Domain/Entities/filter-list.interface';

const filtersUserTable: FilterList[] = [
	{
		label: 'Full name',
		key: 'fullName',
		value: '',
		placeHolder: 'Enter a name',
		type: 'text',
	},
	{
		label: 'Username',
		key: 'username',
		value: '',
		placeHolder: 'Enter a username',
		type: 'text',
	},
	{
		label: 'Email',
		key: 'email',
		value: '',
		placeHolder: 'Enter a email',
		type: 'text',
	},
	{
		label: 'Phone',
		key: 'phone',
		value: '',
		placeHolder: 'Enter a phone',
		type: 'text',
	},
	{
		label: 'Status',
		key: 'status',
		value: '',
		placeHolder: 'Enter a status',
		type: 'text',
	},
];

export default filtersUserTable;
